import ChartJsContainer from "../../../Components/Charts/ChartJs/ChartJs"

const ChartJs = () => {
  return (
    <div className='page-body'>
      <ChartJsContainer />
    </div>
  )
}

export default ChartJs